import React from 'react';
import { Layout } from 'antd';
import BillingInfo from '../billingInfo/BillingInfo';

const { Content } = Layout;

export default function BillingInfoPage() {
    return (
        <Content className="general-layout-content">
            <BillingInfo />
        </Content>
    );
}
